export const pages = [
  { index: 0, name: 'overview.md', route: '/overview' },
  // { index: 1, name: 'education.md', route: '/education' },
  { index: 1, name: 'projects.md', route: '/projects' },
  // { index: 3, name: 'coursework.md', route: '/coursework' },
  { index: 2, name: 'literature.md', route: '/literature' },
  { index: 3, name: 'investing.md', route: '/investing' },
  // { index: 4, name: 'settings.tsx', route: '/settings' },
];
